/* eslint-disable prettier/prettier */
import { Eye, EyeOff } from 'lucide-react';
import React, { useState } from 'react';

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: boolean;
};

export const Input = ({ error = false, className = '', type = 'text', ...props }: InputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === 'password';
  const inputType = isPassword && showPassword ? 'text' : type;

  return (
    <div className="relative">
      <input
        type={inputType}
        className={`w-full px-2 py-1.5 border-[1.5px] bg-white rounded-lg text-medium focus:outline-none focus:ring-1
          ${error ? 'border-red-500 focus:ring-red-500' : 'border-secondary focus:ring-secondary'}
          ${isPassword ? 'pr-9' : ''}
          ${className}`}
        {...props}
      />

      {isPassword && (
        <button
          type="button"
          onClick={() => setShowPassword((prev) => !prev)}
          className="absolute -translate-y-1/2 text-muted top-1/2 right-3"
        >
          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      )}
    </div>
  );
};
